"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugButton = exports.StaticComponentDebugBanner = exports.StaticComponentDebugContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StaticComponentDebugContainer = styled_components_1.default.div `
  border: 2px solid
    ${(props) => props.componentMissing
    ? `rgba(255, 0, 0, ${props.depth * 0.15 + 0.4})`
    : `rgba(0, 147, 255, ${props.depth * 0.15 + 0.4})`};
  width: fit-content;
  min-width: fit-content;
  min-height: 20px;
  display: inline-block;
  position: relative;
`;
exports.StaticComponentDebugBanner = styled_components_1.default.div `
  color: white;
  padding: 10px;
  background-color: ${(props) => props.componentMissing
    ? `rgba(255, 0, 0, ${props.depth * 0.15 + 0.4})`
    : `rgba(0, 147, 255, ${props.depth * 0.15 + 0.4})`};
  width: max(calc(100%), fit-content);
  min-width: max(calc(100%), fit-content);
`;
exports.DebugButton = styled_components_1.default.button `
  min-width: 120px;
  min-height: 25px;
  border-radius: 10px;
  margin: 2px;
  background-color: ${(props) => (props.componentMissing ? `rgba(220, 0, 0, ${props.depth * 0.15 + 0.4})` : '#ffa41c')};
  &:hover {
    background-color: ${(props) => props.componentMissing ? `rgba(255, 0, 0, ${props.depth * 0.15 + 0.4})` : '#ffc43c'};
    transition: 250ms;
  }
  color: white;
  cursor: pointer;
  transition: 250ms;
`;
